import loadable from '@loadable/component';

export const CreditsLinksLoadable = loadable(() => import('./CreditsLinks'), {
  resolveComponent: (module) => module.CreditsLinks,
});
